import { TextTransformationPattern } from "../types";
import { capitalizeAllWords, capitalizeFirstWord, toUppercase } from "../utils";

const useTextTransformationPattern = (
  textTransformationPattern?: TextTransformationPattern,
) => {
  const transformValue = (value: string) => {
    let nextValue = value;
    if (textTransformationPattern === "capitalizeFirstWord") {
      nextValue = capitalizeFirstWord(nextValue);
    }
    if (textTransformationPattern === "capitalizeAllWords") {
      nextValue = capitalizeAllWords(nextValue);
    }
    if (textTransformationPattern === "uppercase") {
      nextValue = toUppercase(nextValue);
    }
    if (textTransformationPattern === "lowercase") {
      nextValue = (value || "").toLowerCase();
    }
    return nextValue;
  };
  return { transformValue };
};
export { useTextTransformationPattern };
